import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import * as graphql from '@treams/treams-network';
import { Button, Heading, Paragraph, tokens } from '@treams/treams-ui';

import Preview from './Preview';

const Main = styled(Box)`
	border-right: 1px solid ${tokens.border.subtle};
`;

const Detail = styled(Box)`
	transition: 0.4s cubic-bezier(0, 1, 0, 1) max-width;
`;

export default function Confirm(props: {
	group: graphql.Group;
	canSelect: boolean;
	single: boolean;
	hasChildren: boolean;
	onSelect: (recursive: boolean) => void;
}) {
	const { t } = useTranslation();

	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setTimeout(() => setMounted(true), 200);
	}, []);

	return (
		<Flex>
			<Main p={3} width={280}>
				<Heading mb={1}>{t('groups.selector.confirm.title')}</Heading>
				{props.hasChildren && !props.single ? (
					props.canSelect ? (
						<>
							<Paragraph>{t('groups.selector.confirm.parent.description')}</Paragraph>
							<Box mt={3}>
								<Button
									title={t('groups.selector.confirm.parent.underlying')}
									onClick={() => props.onSelect(true)}
								/>
								<Button
									title={t('groups.selector.confirm.parent.only')}
									type="secondary"
									mt={2}
									onClick={() => props.onSelect(false)}
								/>
							</Box>
						</>
					) : (
						<>
							<Paragraph>
								{t('groups.selector.confirm.parentWithoutPermission.description')}
							</Paragraph>
							<Box mt={3}>
								<Button
									title={t('groups.selector.confirm.parentWithoutPermission.underlying')}
									onClick={() => props.onSelect(true)}
								/>
							</Box>
						</>
					)
				) : props.single ? (
					props.canSelect ? (
						<>
							<Paragraph>{t('groups.selector.confirm.single.description')}</Paragraph>
							<Button
								mt={3}
								title={t('groups.selector.confirm.single.select')}
								onClick={() => props.onSelect(false)}
							/>
						</>
					) : (
						<>
							<Paragraph>
								{t('groups.selector.confirm.singleWithoutPermission.description')}
							</Paragraph>
							<Button
								mt={3}
								title={t('groups.selector.confirm.single.select')}
								disabled
								onClick={() => {}}
							/>
						</>
					)
				) : (
					<>
						<Paragraph>{t('groups.selector.confirm.child.description')}</Paragraph>
						<Button
							mt={3}
							title={t('groups.selector.confirm.child.select')}
							onClick={() => props.onSelect(false)}
						/>
					</>
				)}
			</Main>
			<Detail maxWidth={mounted ? 240 : 0}>
				<Box width={240}>
					<Preview group={props.group} />
				</Box>
			</Detail>
		</Flex>
	);
}
